var path = '/layout/header.html';
var html = "<img ng-if=\"$ctrl.headerImage\" ng-src=\"{{$ctrl.headerImage}}\" alt=\"{{ 'Registration Header Image' | translate }}\">\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;